import { render, staticRenderFns } from "./radio-input.vue?vue&type=template&id=2146eb45&scoped=true"
import script from "./radio-input.vue?vue&type=script&lang=js"
export * from "./radio-input.vue?vue&type=script&lang=js"
import style0 from "./radio-input.vue?vue&type=style&index=0&id=2146eb45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146eb45",
  null
  
)

export default component.exports